import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { countriesListActions } from '../actions/countries-list.actions';
import { selectCountries, selectCountriesLoaded, selectCountriesLoading } from '../selectors/countries-list.selector';

@Injectable({ providedIn: 'root' })
export class CountriesListFacade {
    private readonly store = inject(Store);

    readonly countries = this.store.selectSignal(selectCountries);
    readonly loaded = this.store.selectSignal(selectCountriesLoaded);
    readonly loading = this.store.selectSignal(selectCountriesLoading);

    readonly countries$ = this.store.select(selectCountries);
    readonly loaded$ = this.store.select(selectCountriesLoaded);
    readonly loading$ = this.store.select(selectCountriesLoading);

    getCountries(): void {
        this.store.dispatch(countriesListActions.getCountriesList());
    }

    clear(): void {
        this.store.dispatch(countriesListActions.clear());
    }
}
